import './style.less';

import Popup from './Popup';
import Notification from './Notification';

Notification.Popup = Popup;

export default Notification;

